import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const MiscVariableOutputGlyph = /*#__PURE__*/createElement("g", {
  id: "misc_variable_output"
}, /*#__PURE__*/createElement("path", {
  d: "M67.87 47h-51.4c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h51.4c.83 0 1.5.67 1.5 1.5s-.68 1.5-1.5 1.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M20.73 52.02c-.38 0-.77-.15-1.06-.44l-4.31-4.31c-.97-.97-.97-2.56 0-3.53l4.31-4.31c.59-.59 1.54-.59 2.12 0s.59 1.54 0 2.12l-3.96 3.96 3.96 3.96c.59.59.59 1.54 0 2.12-.29.28-.67.43-1.06.43zm41.34 4.7c-.83 0-1.5-.67-1.5-1.5 0-14.46-6.68-24.95-15.88-24.95-9.2 0-15.88 10.49-15.88 24.95 0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5c0-16.19 7.94-27.95 18.88-27.95 10.94 0 18.88 11.75 18.88 27.95 0 .83-.67 1.5-1.5 1.5z"
}));
const MiscVariableOutput = createSvg({
  name: 'misc_variable_output',
  path: MiscVariableOutputGlyph
});

export default MiscVariableOutput;
export { MiscVariableOutputGlyph };
